module.exports = __webpack_public_path__ + "img/rate1.81f0f34b.png";